module.exports = __webpack_public_path__ + "img/Feature.8a0e9247.png";